import { waLink, WA_DEFAULT_MESSAGE, track } from "@/constants/site";
import Reveal from "@/components/base/Reveal";

const TRUST = [
  { icon: "ri-shield-check-line", label: "Assistência técnica especializada" },
  { icon: "ri-settings-3-line", label: "Atendimento industrial B2B" },
  { icon: "ri-map-pin-2-line", label: "Sul, Sudeste e Centro-Oeste" },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* discretas linhas técnicas de fundo */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(115deg, oklch(var(--primary-700)) 0, oklch(var(--primary-700)) 1px, transparent 1px, transparent 42px)",
        }}
      />

      <div className="relative mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-10 px-4 pb-16 pt-32 md:px-6 md:pt-40 lg:grid-cols-[55fr_45fr] lg:gap-14">
        <Reveal>
          <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-accent-600">
            <span className="h-px w-6 bg-accent-500" />
            Motores Elétricos • Assistência • Soluções Industriais
          </p>

          <h1 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-foreground-950 md:text-5xl lg:text-6xl">
            Seu motor parou?
          </h1>
          <p className="mt-3 font-heading text-2xl font-bold leading-snug text-primary-700 md:text-3xl">
            A Power ajuda sua operação a voltar ao movimento.
          </p>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            Soluções em motores elétricos e equipamentos industriais para empresas que
            precisam manter suas operações funcionando.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href={waLink(WA_DEFAULT_MESSAGE)}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("whatsapp_click")}
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-[#25D366] px-6 py-3.5 text-base font-bold text-background-50 transition-colors hover:bg-[#1fb959]"
            >
              <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
              Solicitar orçamento no WhatsApp
            </a>
            <a
              href="#solucoes"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3.5 text-base font-bold text-primary-700 transition-colors hover:bg-primary-50"
            >
              Conhecer soluções
              <i className="ri-arrow-down-line" aria-hidden="true" />
            </a>
          </div>

          <p className="mt-4 max-w-md text-sm text-foreground-500">
            Envie as informações do equipamento e conte para nossa equipe o que está acontecendo.
          </p>

          <div className="mt-8 flex flex-wrap gap-x-6 gap-y-3">
            {TRUST.map((t) => (
              <div key={t.label} className="flex items-center gap-2 text-sm font-semibold text-foreground-700">
                <i className={`${t.icon} text-lg text-primary-600`} aria-hidden="true" />
                {t.label}
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={120} className="relative">
          <div className="relative overflow-hidden rounded-lg border border-background-200">
            <img
              src="https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/4f098e48-7792-4e2f-8721-5ef4ca38f372_compressed_powermotoreseletricos-2.webp"
              alt="Motor elétrico WEG azul industrial"
              title="Motor elétrico WEG - Power Motores Elétricos"
              className="h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3 rounded-md bg-background-50/95 px-4 py-3">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-tools-line text-lg" aria-hidden="true" />
              </span>
              <p className="text-sm font-semibold text-foreground-800">
                Manutenção e recuperação de motores elétricos industriais
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}